module.exports = __webpack_public_path__ + "img/bb_g3_mouth-03.5366647e.svg";